import { t } from '@hefe/i18n';
import { BasketballLeague } from '@hefe/models';
import {
  BasketballLeaguesSlice,
  DbbBasketballLeagueUpdateRequest,
  ModalsSlice,
} from '@hefe/store';
import { Space } from 'antd';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

interface EditLeagueFormProps {
  league: BasketballLeague;
}

export default function EditLeagueForm(props: EditLeagueFormProps) {
  const dispatch = useAppDispatch();

  const onSubmit = (values: any, resetForm: any) => {
    const setLoading = ModalsSlice.modalsActions.setModalLoading;

    const submitValues: DbbBasketballLeagueUpdateRequest = {
      id: props.league.id,
      ownReferees: values.own_referees,
      send_score_sheet: false,
    };

    dispatch(setLoading(true));
    dispatch(BasketballLeaguesSlice.updateDbbBasketballLeague(submitValues))
      .unwrap()
      .then(() => {
        resetForm();
        dispatch(ModalsSlice.modalsActions.closeModal());
      })
      .catch(() => null)
      .finally(() => setLoading(false));
  };

  return (
    <Space direction="vertical">
      <CustomForm
        key={`edit-league-form-${props.league.id}`}
        formId={`edit-league-form-${props.league.id}`}
        fields={[
          {
            name: 'own_referees',
            label: '',
            type: 'checkbox',
            checkboxText: t('own_referees') + '?',
            initalValue: props.league.clubData?.ownReferees,
            rules: [],
          },
        ]}
        onSubmit={onSubmit}
      />
    </Space>
  );
}
